import { ButtonComponent } from './button/button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ColorsComponent } from './colors/colors.component';
import { DropdownListComponent } from './dropdown-list/dropdown-list.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { HideTextButtonComponent } from './hide-text-button/hide-text-button.component';
import { MonthSwitchComponent } from './month-switch/month-switch.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { SvgPackComponent } from './svg-pack/svg-pack.component';
import { TabsContentComponent } from './tabs-content/tabs-content.component';
import { TabsHeaderItemComponent } from './tabs-header-item/tabs-header-item.component';
import { TabsHeaderComponent } from './tabs-header/tabs-header.component';
import { TabsSwitchComponent } from './tabs-switch/tabs-switch.component';
import { TagComponent } from './tag/tag.component';
import { ViewSwitchComponent } from './view-switch/view-switch.component';
import { YearSwitchComponent } from './year-switch/year-switch.component';

export const UIKIT_COMPONENTS = [
  FormFieldComponent,
  HideTextButtonComponent,
  ButtonComponent,
  ProgressbarComponent,
  CheckboxComponent,
  ColorsComponent,
  YearSwitchComponent,
  ViewSwitchComponent,
  RadioButtonComponent,
  TagComponent,
  TabsSwitchComponent,
  TabsHeaderComponent,
  TabsHeaderItemComponent,
  TabsContentComponent,
  SvgPackComponent,
  DropdownListComponent,
  MonthSwitchComponent,
];

export * from './button/button.component';
export * from './checkbox/checkbox.component';
export * from './colors/colors.component';
export * from './dropdown-list/dropdown-list.component';
export * from './form-field/form-field.component';
export * from './hide-text-button/hide-text-button.component';
export * from './month-switch/month-switch.component';
export * from './progressbar/progressbar.component';
export * from './radio-button/radio-button.component';
export * from './svg-pack/svg-pack.component';
export * from './tabs-content/tabs-content.component';
export * from './tabs-header-item/tabs-header-item.component';
export * from './tabs-header/tabs-header.component';
export * from './tabs-switch/tabs-switch.component';
export * from './tag/tag.component';
export * from './view-switch/view-switch.component';
export * from './year-switch/year-switch.component';
